import React from 'react';

import { TableContextProvider } from 'lib/context/TableContext/TableContextProvider';

import AdminIntelligenceModelTable from 'components/admin/pages/Intelligence/Model/AdminIntelligenceModelTable';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import { DEFAULT_FILTERS } from './lib/defaultFilters';
import { cols } from './lib/helper';

const AdminIntelligenceModel = () => {
  return (
    <TableContextProvider
      name="admin_intelligence_ai_model_table"
      defaultFilters={DEFAULT_FILTERS}
      cols={cols}
      pagination={true}>
      <AdminIntelligenceModelTable />
    </TableContextProvider>
  );
};

export default withErrorBoundary(AdminIntelligenceModel);
